import React from "react";

import type { WearablesRouteSurface } from "@/lib/wearables/wearables.routeCompanion";

import "./wearables-v2.css";

type Props = {
  statusLabel: string;
  title: string;
  body: string;
  chips: string[];
  currentEntry: boolean;
  destinationLabel: string;
  destinationSurface: WearablesRouteSurface;
  overlayOpen: boolean;
  onAccept: () => void;
  onRevise: () => void;
  onToggleDetails: () => void;
};

export default function WearablesIntercept({
  statusLabel,
  title,
  body,
  chips,
  currentEntry,
  destinationLabel,
  destinationSurface,
  overlayOpen,
  onAccept,
  onRevise,
  onToggleDetails,
}: Props): JSX.Element {
  return (
    <>
      <div className="st-wearables-v2__topline">
        <span className="st-wearables-v2__status-badge">{statusLabel}</span>
        <button
          type="button"
          className="st-wearables-v2__button st-wearables-v2__button--ghost st-wearables-v2__button--compact"
          onClick={onToggleDetails}
        >
          Readiness Compass
        </button>
      </div>

      <div>
        <p className="st-wearables-v2__eyebrow">Wearables Continuity</p>
        <h2 className="st-wearables-v2__title">{title}</h2>
        <p className="st-wearables-v2__body">{body}</p>
      </div>

      <div className="st-wearables-v2__chips">
        {chips.map((chip) => (
          <span key={chip} className="st-wearables-v2__chip">
            {chip}
          </span>
        ))}
      </div>

      <div className="st-wearables-v2__actions">
        <button
          type="button"
          className="st-wearables-v2__button st-wearables-v2__button--primary"
          onClick={onAccept}
        >
          {currentEntry
            ? `Resume ${destinationLabel}`
            : destinationSurface === "omnistudio"
              ? "Open creator flow"
              : destinationSurface === "xr"
                ? "Enter XR flow"
                : "Use this flow"}
        </button>
        <button type="button" className="st-wearables-v2__button" onClick={onRevise}>
          Revise in Wearables
        </button>
      </div>
    </>
  );
}